import Vue from "vue";

Vue.use(require("vue-pusher"), {
  api_key: window.state.pusher_app_key,
  options: window.state.pusher_config,
});
